import { gsap } from "../../node_modules/gsap/index.js";
export class MainMenu {
    animation;
    headerElement;
    constructor() {
        this.menuToggle();
        this.headerElement = jQuery('#masthead');
        this.menuItemClickClose();
        //this.menuClose();
        jQuery('#primary-menu li').each( (i, el) => {
            let w = jQuery(el).width();
            let h = jQuery(el).height();
            jQuery(el).css('width', w);
            jQuery(el).css('height', h);
            jQuery(el).find('a').addClass('positioned');
        });
        jQuery(".menu-item a").click(function () {
            menuClose();
        });
    }
    menuToggle() {
        jQuery('#mainNavigationToggle').on('click', (e) => {
            
            const thisButton = jQuery(e.currentTarget);
            const headerElement = jQuery('#masthead');
            
            if( thisButton.hasClass('menu-open') ) {
                //console.log('menu-open');
                thisButton.removeClass('menu-open');
                thisButton.addClass('menu-close');
                this.menuOpen();
            } else if( thisButton.hasClass('menu-close') ) {
                //console.log('menu-close');
                thisButton.removeClass('menu-close');
                thisButton.addClass('menu-open');
                this.menuClose();
            }

        });

        const hamburger = document.getElementById('hamburger');
        hamburger.addEventListener('click', (e) => {
            const thisButton = jQuery(e.currentTarget);
            const headerElement = jQuery('#masthead');
            hamburger.classList.toggle('open');
            if(thisButton.hasClass('open')) {
                this.menuOpen();
            } else {
                this.menuClose();
            }
        });
    }
    menuOpen() {
        jQuery('html').addClass('blocked');
        this.menuOpenAnimation();
        this.headerElement.addClass('header-menu-open');
    }
    menuClose() {
        jQuery('#mainNavigationClose').removeClass('animate__rotateIn');
        jQuery('html').removeClass('blocked');
        this.animation.reverse(-1);
        this.headerElement.removeClass('header-menu-open');
    }

    menuOpenAnimation() {

        const mm = gsap.matchMedia();

        mm.add({
            // mobile
            isMobile: "(max-width: 767px)",
            // desktop
            isDesktop: "(min-width: 768px)"
        }, (context) => {

            const { isMobile } = context.conditions;

            this.animation = gsap.timeline();
            this.animation.to('#mainNavigationDesktop', {
                bottom: isMobile ? '10vh' : '30vh',
                duration: 0.3
            });

            gsap.utils.toArray('#primary-menu li a').forEach((wrapper) => {
                this.animation.to(wrapper, {
                    top: 0,
                    duration: 0.2
                }, '-=0.15');
            });
        });
    }
    menuItemClickClose() {
        jQuery('.menu-item a').on('click', () => {
            this.menuClose();
            jQuery("#hamburger").removeClass('open');
        });
    }
}
